/* istanbul ignore file */

import React from "react";
import {
  bedragFormatNull,
  getMonthlyAmount,
  monthDivision,
} from "../infra/scenario-utils";
import Table from "../../components/Table";
import { Column } from "../../components/BaseTable";

export interface BrutoInkomensWensenTableProps {
  brutoInkomensWensPercentage: number | null;
  jaarlijkseAnalyse: {
    maandelijksTekorten: (number | null)[];
  };
  gewenstInkomenBedrag: number | null;
}

export const BrutoInkomensWensenTable: React.FC<BrutoInkomensWensenTableProps> = ({
  brutoInkomensWensPercentage,
  jaarlijkseAnalyse,
  gewenstInkomenBedrag,
}: BrutoInkomensWensenTableProps) => {
  const data = jaarlijkseAnalyse.maandelijksTekorten.map((tekort) => ({
    gewenstInkomenValue: bedragFormatNull(gewenstInkomenBedrag, monthDivision),
    maandelijksTekortValue: getMonthlyAmount(tekort),
  }));

  // Filter opeenvolgende dubbele rijen o.b.v. weergegeven kolommen
  const filteredData = data.filter((row, index, arr) => {
    if (index === 0) return true;
    const prev = arr[index - 1];
    return (
      row.gewenstInkomenValue !== prev.gewenstInkomenValue ||
      row.maandelijksTekortValue !== prev.maandelijksTekortValue
    );
  });

  const columns: Column[] = [
    {
      header: `Gewenst inkomen van minimaal ${brutoInkomensWensPercentage}% van huidig bruto inkomen`,
      accessor: "gewenstInkomenValue",
    },
    {
      header: "Maandelijks tekort aan gewenste inkomsten",
      accessor: "maandelijksTekortValue",
      dataType: "currency",
      violation: (value: number | null) => {
        return value != null && value > 0;
      },
    },
  ];

  return (
    <Table
      columns={columns}
      data={filteredData}
      rotate
      id="bruto-inkomens-wensen-table"
      className="scenario__table mb-4 table table-striped table-bordered table-hover table-responsive"
    />
  );
};
